import React from 'react';
import PropTypes from 'prop-types';
// Styles
import styled from 'styled-components';
import Calendar from 'react-calendar/dist/entry.nostyle';
import { lighten } from 'polished';
import moment from 'moment';
import 'moment/locale/pt';

moment.locale('pt')

const ReactCalendar = ({ className, ...props }) => (
  <div className={`${className} custom-react-calendar`}>
    <Calendar
      {...props}
      next2Label={null}
      prev2Label={null}
      locale="pt"
      formatShortWeekday={(locale, date) => moment(date).format('ddd')}
      formatMonthYear={(locale, date) => moment(date).format('MMMM YYYY')}
      formatMonth={(locale, date) => moment(date).format('MMM')}
    />
  </div>
);

ReactCalendar.propTypes = {
  className: PropTypes.string
};

ReactCalendar.defaultProps = {
  className: ''
}

const ReactCalendarWithStyles = styled(ReactCalendar)`
   &.custom-react-calendar {
    position: absolute;
    z-index: ${props => props.theme.values.zIndex.m};
    left: 0;
    width: 350px;
    top: ${props => props.top};

    .react-calendar__tile--active,
    .react-calendar__tile--hasActive,
    .react-calendar__navigation button[disabled] {
      background-color: ${props => props.theme.colors.bgInverse};
      color: ${props => props.theme.colors.base};
    }
    .react-calendar {
      background: ${props => props.theme.colors.bgInverse};
      width: 100%;
      padding: 20px;
      border: none;
    }
    .react-calendar__navigation {
      height: auto;
      margin-bottom: 5px;
      button {
        text-transform: uppercase;
        font-size: 24px;
        font-weight: 100;
        background-color: ${props => props.theme.colors.bgInverse};
        color: ${props => props.theme.colors.baseInverse};
        border-color: ${props => props.theme.colors.bgInverse};
        padding: ${props => props.theme.spacing.xs4} 0;
        &:hover {
          background-color: ${props => lighten(0.3, props.theme.colors.bgInverse)};
          color: ${props => props.theme.colors.baseInverse};
        }
        &:focus {
          outline: 0;
          color: ${props => props.theme.colors.baseInverse};
          background-color: ${props => lighten(0.5, props.theme.colors.bgInverse)};
        }
        &:active {
          background-color: ${props => props.theme.colors.bgDark};
        }
      }
    }
    .react-calendar__tile {
      background-color: ${props => props.theme.colors.bgInverse};
      color: ${props => props.theme.colors.baseInverse};
      border-color: ${props => props.theme.colors.bgInverse};
      padding: ${props => props.theme.spacing.xs2};
      border-style: none;
      &:hover {
      background-color: ${props => lighten(0.3, props.theme.colors.bgInverse)};
      color: ${props => props.theme.colors.baseInverse};
      }
      &:focus {
        outline: 0;
        color: ${props => props.theme.colors.baseInverse};
        background-color: ${props => lighten(0.5, props.theme.colors.bgInverse)};
      }
      &:active {
        background-color: ${props => props.theme.colors.bgDark};
      }
    }
    .react-calendar__navigation__arrow {
      padding: ${props => props.theme.spacing.xs4} ${props => props.theme.spacing.xs} !important;
      cursor: pointer;
      &:hover {
        background-color: ${props => lighten(0.3, props.theme.colors.bgInverse)};
        color: ${props => props.theme.colors.baseInverse};
      }
      &:focus {
        outline: 0;
        color: ${props => props.theme.colors.baseInverse};
        background-color: ${props => lighten(0.5, props.theme.colors.bgInverse)};
      }
      &:active {
        background-color: ${props => props.theme.colors.bgDark};
      }
    }
    .react-calendar__month-view__weekdays__weekday {
      background-color: ${props => props.theme.colors.bgInverse};
      color: ${props => props.theme.colors.baseInverse};
      border-color: ${props => props.theme.colors.bgInverse};
      outline: none;
      font-size: ${props => props.theme.sizes.s};
      display: flex;
      justify-content: center;
      padding: ${props => props.theme.spacing.xs3} 0;
    }

    abbr[title] {
      text-decoration: none;
    }
    .react-calendar__month-view__days__day--neighboringMonth {
      color: ${props => props.theme.colors.baseLighterS};
    }
`;

ReactCalendarWithStyles.propTypes = {
  right: PropTypes.string,
  left: PropTypes.string,
  top: PropTypes.string,
};


export default ReactCalendarWithStyles;
